import axios from "../api/axios";

export default {
  async updateStateReview(id) {
    await axios.put(`/reviews/stateReview?id=${id}`);
  },
};
